export default {
  id: 68,
  title: 'Target #68 - Bell',
  url: 'https://cssbattle.dev/play/68',
  colors: ['#191919', '#E08027', '#F2AD43', '#824B20'],
  solution:
    '<a a><a b><style>body{background:#191919}a{position:fixed}a[a]{top:66;left:175;width:50;height:50;border-radius:50%;background:#f2ad43;box-shadow:0 120px #824b20}a[b]{top:90;left:140;width:120;height:120;border-radius:60px 60px 10px 10px;background:#e08027}</style>',
}
